(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clack-dynamic"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-cl-dynamic]');
  if (!root || !window.fetch) return;
  const strings = JSON.parse(root.querySelector('[data-cl-strings]').textContent);
  const base = root.dataset.root.replace(/\/?$/, '/');
  const dialog = root.querySelector('dialog');
  if (typeof dialog.showModal !== 'function') return;
  const status = root.querySelector('.cl-drawer-status');
  const lines = root.querySelector('[data-cl-cart-lines]');
  const checkout = root.querySelector('[data-cl-checkout]');
  let cart = null;
  let busy = false;
  const msg = (key, replacements = {}) => Object.entries(replacements).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', String(value)), strings[key]);
  const money = value => new Intl.NumberFormat(root.dataset.locale, {style:'currency',currency:cart.currency,currencyDisplay:'code'}).format(value / 100);
  function node(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  async function request(path, options = {}) {
    const response = await fetch(base + path, {...options, headers: {'Accept':'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : strings.error);
    return data;
  }
  function lock(value) {
    busy = value;
    lines.querySelectorAll('button').forEach(button => button.disabled = value);
    checkout.disabled = value || !cart?.item_count;
    lines.setAttribute('aria-busy', String(value));
  }
  function render(data) {
    cart = data;
    document.querySelectorAll('[data-cl-cart-count]').forEach(el => el.textContent = cart.item_count);
    root.querySelector('[data-cl-drawer-count]').textContent = msg(cart.item_count===1?'item':'items', {count:cart.item_count});
    root.querySelector('[data-cl-subtotal]').textContent = money(cart.total_price);
    lines.replaceChildren();
    if (!cart.item_count) lines.append(node('p', 'cl-copy', strings.empty));
    cart.items.forEach(item => {
      const row = node('article','cl-cart-line');
      const link = node('a');
      link.href = item.url;
      link.tabIndex = -1;
      link.setAttribute('aria-hidden','true');
      const src = item.featured_image?.url || item.image;
      if (src) {const img = node('img');img.src = src;img.alt = '';img.width=86;img.height=100;img.loading='lazy';link.append(img);}
      const info = node('div');
      const title = node('a','cl-line-title',item.product_title);
      title.href = item.url;
      info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p','cl-line-variant',item.variant_title));
      info.append(node('p','cl-line-price',money(item.final_line_price)));
      const actions=node('div','cl-line-actions'),quantity=node('div','cl-line-quantity');
      quantity.setAttribute('role','group');quantity.setAttribute('aria-label',msg('quantity',{title:item.product_title}));
      const minus=node('button',null,'−'),plus=node('button',null,'+'),remove=node('button','cl-line-remove',strings.remove);
      [minus,plus,remove].forEach(button=>button.type='button');
      minus.setAttribute('aria-label',msg('decrease',{title:item.product_title}));
      plus.setAttribute('aria-label',msg('increase',{title:item.product_title}));
      minus.addEventListener('click',()=>change(item.key,Math.max(0,item.quantity-1),'decrease'));
      plus.addEventListener('click',()=>change(item.key,item.quantity+1,'increase'));
      remove.addEventListener('click',()=>change(item.key,0,'remove'));
      minus.dataset.action='decrease';plus.dataset.action='increase';remove.dataset.action='remove';row.dataset.key=item.key;
      quantity.append(minus,node('span',null,item.quantity),plus);actions.append(quantity,remove);info.append(actions);row.append(link,info);lines.append(row);
    });
    lock(busy);
  }
  async function change(key, quantity, action) {
    if (busy) return;
    lock(true);status.textContent = strings.loading;
    try {
      render(await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})}));
      status.textContent = strings.updated;
      lock(false);
      const row = Array.from(lines.children).find(el=>el.dataset.key===key);
      const focusTarget = row?.querySelector('[data-action="'+action+'"]') || root.querySelector('[data-cl-close]');
      focusTarget.focus();
    } catch (error) {status.textContent=error.message;} finally {lock(false);}
  }
  function open() {if (!dialog.open) {dialog.showModal();document.body.classList.add('cl-cart-open');}}
  dialog.addEventListener('close',()=>document.body.classList.remove('cl-cart-open'));
  dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
  root.querySelectorAll('[data-cl-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  document.querySelectorAll('.cl-cart-link').forEach(link=>link.addEventListener('click',async event=>{
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||busy)return;
    event.preventDefault();open();lock(true);status.textContent=strings.cart_loading;
    try {render(await request('cart.js'));status.textContent='';}catch(error){status.textContent=strings.cart_error;}finally{lock(false);}
  }));
  function bind(scope=document) {
    scope.querySelectorAll('.cl-quick-form,.cl-product-form').forEach(form=>{
      if(form.dataset.clAjax)return;
      form.dataset.clAjax='true';
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(form.dataset.clPending||busy)return;
        form.dataset.clPending='true';
        const button=form.querySelector('[name="add"]'),message=form.querySelector('.cl-form-message');
        button.disabled=true;button.setAttribute('aria-busy','true');message.textContent=strings.loading;
        let added=false;lock(true);
        try {
          await request('cart/add.js',{method:'POST',body:new FormData(form)});added=true;
          render(await request('cart.js'));status.textContent='';message.textContent='';open();
        } catch(error) {message.textContent=added?strings.added_error:error.message;} finally {
          delete form.dataset.clPending;const option=form.querySelector('[data-variant]')?.selectedOptions[0];button.disabled=option?.dataset.available==='false';button.removeAttribute('aria-busy');lock(false);
        }
      });
    });
    scope.querySelectorAll('[data-cl-filters]').forEach(filters=>{
      if(filters.dataset.clBound)return;
      filters.dataset.clBound='true';filters.hidden=false;
      const cards=filters.parentElement.querySelectorAll('.cl-card');
      filters.querySelectorAll('[data-cl-filter]').forEach(button=>button.addEventListener('click',()=>{
        let count=0;
        cards.forEach(card=>{card.hidden=button.dataset.clFilter!=='all'&&!card.dataset.clCategories.split(' ').includes(button.dataset.clFilter);if(!card.hidden)count++;});
        filters.querySelectorAll('button').forEach(el=>el.setAttribute('aria-pressed',String(el===button)));
        filters.querySelector('[data-cl-filter-status]').textContent=msg('results',{count});
      }));
    });
    scope.querySelectorAll('[data-cl-product]').forEach(product=>{
      if(product.dataset.clStickyBound)return;
      product.dataset.clStickyBound='true';
      const sticky=product.querySelector('.cl-mobile-buy'),button=product.querySelector('[data-add]');
      if(!sticky||!button||!window.IntersectionObserver)return;
      sticky.querySelector('button').addEventListener('click',()=>product.querySelector('.cl-product-form').requestSubmit());
      new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting;},{threshold:0,rootMargin:'-110px 0px 0px 0px'}).observe(button);
    });
    if(window.IntersectionObserver&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('cl-reveal');observer.unobserve(entry.target);}}),{threshold:.08});
      scope.querySelectorAll('.cl-section-head,.cl-card,.cl-product-delivery').forEach(el=>observer.observe(el));
    }
  }
  document.addEventListener('click',event=>{if(event.target.closest('.cl-mobile nav a'))document.querySelector('.cl-mobile')?.removeAttribute('open');});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelector('.cl-mobile')?.removeAttribute('open');});
  document.addEventListener('clack:content-ready',event=>bind(event.detail?.scope||document));
  bind();document.addEventListener('shopify:section:load',event=>bind(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clack-experience"]) return;
  try {
    
(() => {
 const root=document.querySelector('[data-cl-experience]');if(!root)return;
 const preview=root.querySelector('.cl-preview-dialog'),photoDialog=root.querySelector('.cl-photo-dialog');
 let sourceForm=null;
 const closeDialog=dialog=>dialog.close();
 [preview,photoDialog].forEach(dialog=>{dialog.addEventListener('close',()=>{if(!preview.open&&!photoDialog.open)document.body.classList.remove('cl-preview-open');});dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)closeDialog(dialog);}});});
 root.querySelector('[data-cl-preview-close]').addEventListener('click',()=>closeDialog(preview));root.querySelector('[data-cl-photo-close]').addEventListener('click',()=>closeDialog(photoDialog));
 root.querySelector('[data-cl-preview-add]').addEventListener('click',()=>{if(!sourceForm)return;closeDialog(preview);sourceForm.requestSubmit();});
 function bind(scope=document){
  if(typeof preview.showModal==='function'){
   scope.querySelectorAll('[data-cl-quickview]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.hidden=false;button.addEventListener('click',()=>{const card=button.closest('.cl-card'),template=card.querySelector('[data-cl-preview-template]');if(!template)return;root.querySelector('#ClackPreviewTitle').textContent=card.dataset.clProductName;root.querySelector('.cl-preview-body').replaceChildren(template.content.cloneNode(true));root.querySelector('[data-cl-preview-link]').href=card.querySelector('.cl-card-media').href;sourceForm=card.querySelector('.cl-quick-form');const add=root.querySelector('[data-cl-preview-add]');add.hidden=!sourceForm;add.disabled=!!sourceForm?.querySelector('[name="add"]')?.disabled;preview.showModal();document.body.classList.add('cl-preview-open');});});
   scope.querySelectorAll('[data-cl-photo-open]').forEach(button=>{if(button.dataset.bound)return;button.dataset.bound='true';button.hidden=false;button.addEventListener('click',()=>{const current=button.closest('.cl-main-image').querySelector('.cl-current-photo');if(!current)return;const image=document.createElement('img');image.src=current.src||current.currentSrc;image.alt=current.alt;root.querySelector('.cl-photo-body').replaceChildren(image);root.querySelector('.cl-photo-caption').textContent=current.alt;photoDialog.showModal();document.body.classList.add('cl-preview-open');});});
  }
  scope.querySelectorAll('[data-cl-scenes]').forEach(section=>{if(section.dataset.a1Bound)return;section.dataset.a1Bound='true';const track=section.querySelector('.cl-scenes'),controls=section.querySelector('.cl-scenes-controls');controls.hidden=false;function update(){controls.querySelector('[data-cl-scenes-prev]').disabled=track.scrollLeft<5;controls.querySelector('[data-cl-scenes-next]').disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-5;}function move(direction){track.scrollBy({left:direction*(track.querySelector('.cl-scene')?.getBoundingClientRect().width+20||track.clientWidth),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}controls.querySelector('[data-cl-scenes-prev]').addEventListener('click',()=>move(-1));controls.querySelector('[data-cl-scenes-next]').addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});update();});
 }
 bind();document.addEventListener('shopify:section:load',event=>bind(event.target));
 const progress=root.querySelector('.cl-scroll-progress'),top=root.querySelector('.cl-back-top');let scheduled=false;
 function updateScroll(){const height=document.documentElement.scrollHeight-window.innerHeight;progress.style.transform='scaleX('+(height>0?Math.min(1,Math.max(0,window.scrollY/height)):0)+')';top.hidden=window.scrollY<900;scheduled=false;}
 window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateScroll);}},{passive:true});window.addEventListener('resize',updateScroll,{passive:true});updateScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clack-finder"] && !Shopify.designMode) return;
  try {
    
function bindClackFinder(scope=document){scope.querySelectorAll('[data-cl-finder]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';root.hidden=false;document.querySelectorAll('[data-cl-showcase-guide]').forEach(link=>link.href='#clack-guide');let goal='';let goalText='';const steps=Array.from(root.querySelectorAll('[data-cl-guide-step]')),progress=root.querySelector('[data-cl-guide-progress]');function stage(name){steps.forEach(step=>step.hidden=step.dataset.clGuideStep!==name);progress.style.width=({goal:'33.333%',place:'66.666%',result:'100%'})[name];const current=steps.find(step=>step.dataset.clGuideStep===name);current.querySelector('h3').focus({preventScroll:true});if(root.getBoundingClientRect().top<-180)current.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});}root.querySelectorAll('[data-cl-goal]').forEach(button=>button.addEventListener('click',()=>{goal=button.dataset.clGoal;goalText=button.querySelector('strong').textContent;stage('place');}));root.querySelectorAll('[data-cl-place]').forEach(button=>button.addEventListener('click',()=>{const place=button.dataset.clPlace;const key=goal==='force'?(place==='gym'?'lift':'flex'):({film:'frame',cardio:'pulse',organize:'hold',grip:'force'})[goal];let match=false;root.querySelectorAll('[data-cl-guide-result]').forEach(result=>{result.hidden=result.dataset.clGuideResult!==key;if(!result.hidden)match=true;});root.querySelector('[data-cl-guide-choice]').textContent=goalText;root.querySelector('.cl-finder-fallback').hidden=match;stage('result');}));root.querySelector('[data-cl-guide-back]').addEventListener('click',()=>stage('goal'));root.querySelector('[data-cl-guide-reset]').addEventListener('click',()=>{goal='';stage('goal');});});}bindClackFinder();document.addEventListener('shopify:section:load',event=>bindClackFinder(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clack-product"] && !Shopify.designMode) return;
  try {
    
function bindClackProducts(scope=document){scope.querySelectorAll('[data-cl-product]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const photo=root.querySelector('.cl-current-photo'),select=root.querySelector('[data-variant]'),price=root.querySelector('[data-price]'),button=root.querySelector('[data-add]');function setPhoto(src,alt){if(photo&&src){photo.removeAttribute('srcset');photo.src=src;if(alt)photo.alt=alt;}}root.querySelectorAll('[data-photo]').forEach(el=>el.addEventListener('click',()=>{setPhoto(el.dataset.photo,el.dataset.alt);root.querySelectorAll('[data-photo]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===el)));}));select?.addEventListener('change',()=>{const option=select.selectedOptions[0];price.textContent=option.dataset.price;const stickyPrice=root.querySelector('[data-cl-sticky-price]');if(stickyPrice)stickyPrice.textContent=option.dataset.price;button.disabled=option.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.label;const stickyButton=root.querySelector('[data-cl-sticky-add]');if(stickyButton){stickyButton.disabled=button.disabled;stickyButton.textContent=button.textContent;}setPhoto(option.dataset.image,option.textContent);const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);});});}bindClackProducts();document.addEventListener('shopify:section:load',event=>bindClackProducts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clack-showcase"] && !Shopify.designMode) return;
  try {
    
function bindClackShowcase(scope=document){scope.querySelectorAll('[data-cl-showcase]').forEach(root=>{if(root.dataset.bound)return;root.dataset.bound='true';const panels=Array.from(root.querySelectorAll('[data-cl-showcase-panel]')),buttons=Array.from(root.querySelectorAll('[data-cl-showcase-select]'));if(!panels.length)return;let index=0;function show(next){index=(next+panels.length)%panels.length;panels.forEach((panel,i)=>{panel.hidden=i!==index;panel.classList.toggle('cl-stage-enter',i===index);});buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));}root.querySelector('.cl-showcase-tabs').hidden=false;root.querySelector('.cl-showcase-arrows').hidden=panels.length<2;buttons.forEach((button,i)=>button.addEventListener('click',()=>show(i)));root.querySelector('[data-cl-showcase-prev]').addEventListener('click',()=>show(index-1));root.querySelector('[data-cl-showcase-next]').addEventListener('click',()=>show(index+1));document.addEventListener('shopify:block:select',event=>{const index=panels.findIndex(panel=>panel.dataset.clShowcasePanel===event.detail.blockId);if(index>=0)show(index);});});}bindClackShowcase();document.addEventListener('shopify:section:load',event=>bindClackShowcase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clack-studio"] && !Shopify.designMode) return;
  try {
    
  function setupClackStudio(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const menu = root.querySelector('.clack-mobile-menu');
    if (menu) {
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    }
    root.querySelectorAll('.clack-contact-form').forEach(form => {
      if (form.querySelector('[role="status"], [role="alert"]')) form.closest('details').open = true;
    });
  }
  document.querySelectorAll('.clack-studio').forEach(setupClackStudio);
  document.addEventListener('shopify:section:load', event => setupClackStudio(event.target.querySelector('.clack-studio')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
